exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal[_v-4e47114f] {\n  position: fixed;\n  left: 40%;\n  top: 10px;\n  z-index: 100000;\n  -ms-flex-align: center;\n      align-items: center;\n  text-align: center;\n}\n.modal .shadow[_v-4e47114f] {\n  box-shadow: 0 3px 10px rgba(202, 195, 195, 0.5);\n}\n.modal .shadow .icon[_v-4e47114f] {\n  background-color: orangered;\n  width: 50px;\n  height: 31px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border-radius: 2px 0px 0px 2px;\n  border: 1px solid #f1f1f1;\n}\n.modal .shadow .message[_v-4e47114f] {\n  left: 50px;\n  position: absolute;\n  width: 150px;\n  background-color: white;\n  padding: 5px 60px 5px 10px;\n  border-radius: 0px 2px 2px 0px;\n  border: 1px solid #f1f1f1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-4e47114f&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/common/dialog/MessageBox.vue
// module id = 1712
// module chunks = 38